/**
 * EpisodeCardSkeleton — visual placeholder shown while the homepage
 * "Latest" feed is loading. Same outer dimensions as the real
 * EpisodeCard so the page doesn't reflow when content lands.
 *
 * Animation: tailwind's animate-pulse on the gray blocks; no GIF/SVG —
 * keeps the placeholder under 0.5 KB of HTML and respects
 * prefers-reduced-motion (Tailwind's pulse honors the media query).
 */
export default function EpisodeCardSkeleton({ featured = false }) {
  return (
    <div
      className="card-ep p-0 overflow-hidden animate-pulse"
      data-testid="episode-card-skeleton"
      aria-busy="true"
      aria-label="Carregando episódio"
    >
      <div className={`bg-slate-800/70 ${featured ? "aspect-[16/9]" : "aspect-video"}`} />
      <div className="p-4 space-y-3">
        <div className="h-3 w-1/3 rounded bg-slate-800/70" />
        <div className="h-4 w-11/12 rounded bg-slate-800/70" />
        <div className="h-4 w-3/4 rounded bg-slate-800/70" />
        <div className="flex items-center gap-2 pt-2">
          <div className="h-3 w-12 rounded-full bg-slate-800/60" />
          <div className="h-3 w-16 rounded-full bg-slate-800/60" />
        </div>
      </div>
    </div>
  );
}
